export const PAGE_SIZE = 21;
export const PAGE_SIZES = [21, 61, 101];
export const ENABLE_PAGINATION = false;
export const ENABLE_SEARCH = false;
